module.exports = __webpack_public_path__ + "static/media/emma_vp_red_square.52c1d7cf.jpg";